// used by mailchimp
"use client"
import { useState, useEffect } from 'react';

const CheckCardEntity = ({ caption, id, defaultChecked, text1, text2, text3, callback, fullEntity, hasExistingRelation  }) => {
  // has existing relation = candidate already submitted, etc. 
     const [checked, setChecked] = useState(false)

     const handleCheck = (checkedId) => {
          
          if (checked === checkedId){
               setChecked(!checked)
               callback({uncheckedId: checked, fullEntity: fullEntity})
          }
          else { 
               setChecked(checkedId)
               callback({checkedId: checkedId, fullEntity: fullEntity })
          }


     }

     useEffect(() => {
       defaultChecked && setChecked(id)
     }, [defaultChecked])
     
     return (
          // <label 
          // className={`w-full cursor-pointer ${checked === id ? 'bg-indigo-700 dark:bg-indigo-700 text-white dark:text-white' : 'bg-gray-100'} bg-gray-200 dark:text-gray-400 dark:bg-slate-800 inline-flex items-center rounded m-1 px-3 text-xs py-1 duration-300 hover:bg-indigo-700 hover:text-white font-inter`} 
          // htmlFor={`group_${id}`}
          // >
          // <input 
          //      type="checkbox" 
          //      id={`group_${id}`} 
          //      name={`group[22182][${id}]`} 
          //      value={id} 
          //      className="av-checkbox" 
          //      onClick={()=>handleCheck(id)}
          //      style={{ opacity: 0, width: 0, height: 0}}
          // />
          // {caption}
          // </label>


          //          <label 
          // className={`w-full cursor-pointer border-2 border-gray-100 dark:border-slate-800 ${checked === id ? 'border-teal-400 dark:border-teal-400 dark:text-white' : 'bg-gray-100'} dark:text-gray-400 dark:bg-slate-800 inline-flex items-center rounded-lg m-1 px-3 text-xs py-1 duration-300 hover:border-teal-400 font-inter`} 
          // htmlFor={`group_${id}`}
          // >
          //                  <input 
          //                type="checkbox" 
          //                id={`group_${id}`} 
          //                name={`group[22182][${id}]`} 
          //                value={id} 
          //                className="av-checkbox" 
          //                onClick={()=>handleCheck(id)}
          //                style={{ opacity: 0, width: 0, height: 0}}
          //           />
          //       <div className="w-full bg-inherit justify-center dark:border-gray-800 mb-1">
          //         <div className={`transition duration-300 py-3`}>
          //           <div className="p-2">
          //             <div className="flex justify-between items-center">
          
          //               <span className="font-bold text-left text-sm text-black dark:text-white leading-8 mx-5 whitespace-nowrap overflow-hidden">
          //                {text1}
          //               </span>
          
          //               <span className={`text-sm text-black dark:text-white dark:text-gray-300 mx-5 whitespace-nowrap overflow-hidden `}>
          //               {text2}
          //               </span>
          //             </div>
          
        
          //             <div className="ml-5 dark:text-white text-sm">
          //             {text3}
          //             </div>
          //             <div className="text-left mt-2 ml-5">
          //             </div>

          //           </div>
          //         </div>
          //       </div>
          //       </label>

          <label 
  className={`w-full ${hasExistingRelation ? 'cursor-not-allowed' : 'cursor-pointer'} border border-gray-100 dark:border-slate-800 ${checked === id ? 'border-teal-400 dark:border-teal-400 dark:text-white' : ''} dark:text-gray-400 dark:bg-slate-800 inline-flex items-center rounded-lg px-3 text-xs py-1 duration-300 ${hasExistingRelation && 'hover:border-teal-400'} font-inter`} 
  htmlFor={`group_${id}`}
>
  <input 
  disabled={hasExistingRelation}
  checked={hasExistingRelation}
    type="checkbox" 
    id={`group_${id}`} 
    name={`group[22182][${id}]`} 
    value={id} 
    className="av-checkbox" 
    onChange={() => handleCheck(id)} 
    style={{ opacity: 0, width: 0, height: 0 }}
  />
  
  {/* Card container */}
  <div className="w-full bg-inherit justify-center dark:border-gray-800 mb-1 flex items-center">
    {/* Checkmark positioned to the left and vertically centered */}
    <div className={`flex items-center justify-center w-6 h-6 mr-1 border border-slate-200 dark:border-slate-400 rounded-full p-3`}>

    {checked === id && <i className="fa-solid fa-check text-xl text-teal-400"></i>}
    </div>

    {/* Card Content */}
    <div className={`transition duration-300 py-3 flex-grow`}>
      <div className="p-2">
        {/* <div onClick={()=>console.log('test')} className='flex justify-end z-50'><i className="fa-solid fa-binoculars"></i></div> */}
        <div className="flex justify-between items-center">
          <span className="font-bold font-inter text-left text-sm text-black dark:text-white leading-8 mx-5 whitespace-nowrap overflow-hidden">
            {text1 || 'text1'}
          </span>
          {text2 && <span className={`text-sm text-black dark:text-white dark:text-gray-300 mx-5 overflow-hidden`}>
            {text2 || 'text2'}
          </span>}
        </div>

        {text3 && <div className="ml-5 dark:text-white text-sm">
          {text3 || 'text3'}
        </div>}
      </div>
    </div>
  </div>
</label>

)};

export default CheckCardEntity




